import React, { useState } from 'react';
import LoadingMask from "react-loadingmask";
import SideBar from '../../shared/pageComponent/SideBar';
import HeaderFile from '../../shared/pageComponent/HeaderFile';
import './DashboardStructure.scss';
import { ToastContainer, Zoom } from 'react-toastify';
import { Numbers } from '../../../constants/constant';

const DashboardStructure = ({ title, children, history, ...props }) => {
  // Off-canvas sidebar state — only meaningful below the mobile breakpoint
  // (see sideBar.scss); harmless no-op above it since the sidebar is always
  // visible there regardless of this flag.
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <LoadingMask loading={props.loading} text={"loading..."}>
      <div className="main-container">
        <SideBar isOpen={sidebarOpen} onClose={closeSidebar} />
        {sidebarOpen && (
          <div className="sidebar-backdrop" onClick={closeSidebar} />
        )}
        <div className="content-box">
          <ToastContainer
            position="top-center"
            autoClose={Numbers.twoThou}
            transition={Zoom}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
          />
          <HeaderFile
            title={title}
            history={history}
            onToggleSidebar={() => setSidebarOpen((open) => !open)}
          />
          {children}
        </div>
      </div>
    </LoadingMask>
  )
}
export default DashboardStructure;
